import { Link } from 'react-router-dom';

import { ChartColumnDecreasing } from 'lucide-react';
import moment from 'moment';
import queryString from 'query-string';
import { DefaultTooltip } from 'twyne-new.ui'

import { getInfo } from '@Components/Grid/components/Table/formatters';

export default function ReportLink({ info }) {
  const { row } = getInfo(info)

  const date = moment().format('MM-DD-YYYY')
  const metrics = ['avgLatency', 'successCalls', 'prepingSuccessful', 'rulesSuccessful']
  const groupby = ['integration', 'hour']
  const sortby = ['hour:nested']
  const filterby = JSON.stringify({ integration: [row?.id?.toString()] })

  const query = queryString.stringify({ filterby, startDate: date, endDate: date, metrics, groupby, sortby })

  return <DefaultTooltip content='Show integration report' side='left'>
    <Link className='action' to={{ pathname: '/reports/integration', search: query }}>
      <ChartColumnDecreasing size={16} />
    </Link>
  </DefaultTooltip>
}
